import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import ErrorIcon from '@material-ui/icons/Error';
import InfoIcon from '@material-ui/icons/Info';
import CloseIcon from '@material-ui/icons/Close';
import { amber, green } from '@material-ui/core/colors';
import IconButton from '@material-ui/core/IconButton';
import Snackbar from '@material-ui/core/Snackbar';
import SnackbarContent from '@material-ui/core/SnackbarContent';
import WarningIcon from '@material-ui/icons/Warning';
import { makeStyles } from '@material-ui/core/styles';
import InjectStore from './InjectStore';
import { Icon } from '@material-ui/core';
// import { useStaticRendering } from 'mobx-react';

// useStaticRendering(typeof window === 'undefined');

const variantIcon = {
    success: CheckCircleIcon,
    warning: WarningIcon,
    error: ErrorIcon,
    info: InfoIcon,
    caution: Icon,
};

const useStyles1 = makeStyles((theme) => ({
  success: {
    backgroundColor: green[600] + " !important",
  },
  error: {
    backgroundColor: theme.palette.error.dark + " !important",
  },
  info: {
    backgroundColor: theme.palette.primary.main + " !important",
  },
  warning: {
    backgroundColor: amber[700] + " !important",
  },
  caution: {
    backgroundColor: 'black' + " !important",
  },
  icon: {
    fontSize: 20,
  },
  iconVariant: {
    opacity: 0.9,
    marginRight: theme.spacing(1),
  },
  message: {
    display: "flex",
    alignItems: "center",
  },
}));

function SnackbarContentWrapper(props) {
    const classes = useStyles1();
    const { className, message, onClose, variant, ...other } = props;
    const Icon = variantIcon[variant];

    return (
        <SnackbarContent
            className={clsx(classes[variant], className)}
            aria-describedby="client-snackbar"
            message={
                <span id="client-snackbar" className={classes.message} >
                    <Icon className={clsx(classes.icon, classes.iconVariant)} />
                    <span dangerouslySetInnerHTML={{__html: message}} />
                </span>
            }
            action={[
                <IconButton key="close" aria-label="close" color="inherit" onClick={onClose}>
                    <CloseIcon className={classes.icon} />
                </IconButton>,
            ]}
            {...other}
        />
    );
}

SnackbarContentWrapper.propTypes = {
  className: PropTypes.string,
  message: PropTypes.string,
  onClose: PropTypes.func,
  variant: PropTypes.oneOf(["error", "info", "success", "warning", "caution"])
    .isRequired,
};

function CustomSnackbar(props) {
    const store = props.store

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }

        store.open = false;
    };

    return (
        <Snackbar
            anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
            }}
            open={store.open}
            autoHideDuration={5000}
            onClose={handleClose}
        >
            <SnackbarContentWrapper
                onClose={handleClose}
                variant={store.variant}
                message={store.message}
            />
        </Snackbar>
    );
}

export default InjectStore(CustomSnackbar);